if (!customElements.get('predictive-search-component')) {
  class PredictiveSearchComponent extends HTMLElement {
    constructor() {
      super();

      // === References ===
        this.collproductSearch = this.querySelector('[ref="collectionsSsearch"]');
        this.vendorName = this.querySelector('#collections_tags_here .facets__link');

      this.searchInput = this.querySelector('[ref="searchInput"]');  
      this.resultsContainer = this.querySelector('[data-target="predictiveSearchResults"]');
      this.sortByContainer = this.querySelector('[ref="TopBarSortBy"]');
      this.resetButton = document.querySelector('[ref="resetButton"]');
      this.vendorWrapper = document.querySelector('#vendor_wrapper');
      this.activeItem = document.querySelector('#active_item'); // active_item reference
      this.searchMiniBox = document.querySelector('#search_mini_box'); // mini box reference
      this.SearchRemoveid = document.querySelector('#search_remove_icon'); // remove button
      this.tagWrapper = document.querySelector('#tag_wrapper');
      // this.SearchRemoveid = document.querySelector('#search_remove_icon'); // remove button

      if (!this.searchInput || !this.resultsContainer || !this.resetButton || !this.vendorWrapper) return;

      this.debounceTimeout = null;
      this.defaultResultsHTML = this.resultsContainer.innerHTML;
      this.defaultSortByHTML = this.sortByContainer.innerHTML;

      // === Search input events with debounce ===
      this.searchInput.addEventListener('input', () => this.onInputChange());
      this.searchInput.addEventListener('keydown', (e) => this.onKeyDown(e));

      // === Reset button ===
      this.resetButton.addEventListener('click', () => this.resetSearch());






      
   // === Combined Filter: Search OR Vendor Checkbox + Live Count 
if (this.collproductSearch) {
  let filterTimeout = null;

  const runCombinedFilter = () => {
    const searchVal = this.collproductSearch?.value.trim().toLowerCase() || '';

    // === Push searchVal to .active_item in real-time ===
    const activeItemEl = document.querySelector('#active_item');
    if (activeItemEl) {
      activeItemEl.textContent = searchVal; // text push করল
    }

    //  checked vendors
    const checkedVendorInputs = document.querySelectorAll('#collections_tags_here .facets__link input[type="checkbox"]:checked');
    const checkedVendors = Array.from(checkedVendorInputs).map(input =>
      input.closest('.facets__link').getAttribute('data-vendor').trim().toLowerCase()
    );

    // checked tags
    const checkedTagInputs = document.querySelectorAll('#collections_handle_filter_tag .facets__link input[type="checkbox"]:checked');
    const checkedTags = Array.from(checkedTagInputs).map(input =>
      input.closest('.facets__link').getAttribute('data-tag').trim().toLowerCase()
    );

    const products = document.querySelectorAll('.product-grid .product-grid__item');
    let matchCount = 0;

    products.forEach(item => {
      const titleEl = item.querySelector('.title_text h6');
      const gridTitleEl = item.querySelector('.product_title');
      if (!titleEl || !gridTitleEl) return;

      const titleText = titleEl.textContent.trim().toLowerCase();
      const gridTitleText = gridTitleEl.textContent.trim().toLowerCase();

      // সব .product_tags_here element নিয়ে array বানানো
      const productTagEls = item.querySelectorAll('.product_tags_here');
      const productTags = Array.from(productTagEls).map(el => el.dataset.tag.toLowerCase());

      // match: search OR vendor OR tag
      const matchSearch = searchVal !== '' && gridTitleText.includes(searchVal);
      const matchVendor = checkedVendors.some(vendor => titleText.includes(vendor));
      const matchTag = checkedTags.some(tag => productTags.includes(tag));

      if (matchSearch || matchVendor || matchTag || (searchVal === '' && checkedVendors.length === 0 && checkedTags.length === 0)) {
        item.style.display = 'block';
        matchCount++;
      } else {
        item.style.display = 'none';
      }
    });

    // live product count
    const countEl = document.querySelector('.product_count_one');
    if (countEl) {
      countEl.innerHTML = `Showing <span>${matchCount}</span> Products`;
    }
  };

  // === Search Input Filter (500ms delay) === 
  this.collproductSearch.addEventListener('input', () => {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(runCombinedFilter, 500);
  });

  // === Vendor Checkbox Filter (instant) === 
  const vendorLinks = document.querySelectorAll('#collections_tags_here .facets__link input[type="checkbox"]');
  vendorLinks.forEach(input => {
    input.addEventListener('change', runCombinedFilter);
  });

  const tagstLinks = document.querySelectorAll('#collections_handle_filter_tag .facets__link input[type="checkbox"]');
  tagstLinks.forEach(input => {
    input.addEventListener('change', runCombinedFilter);
  });
}















      // === Search remove icon (#search_remove_icon) ===  New code
      if (this.SearchRemoveid) {
        this.SearchRemoveid.addEventListener('click', () => {
          this.searchInput.value = ''; //  Clear input
          if (this.activeItem) this.activeItem.innerHTML = ''; //  Clear active item
          if (this.searchMiniBox) this.searchMiniBox.style.display = 'none'; //  Show mini box

          // Remove q from URL 
          const url = new URL(location);
          url.searchParams.delete('q');
          history.replaceState(null, '', url.toString());

          // 🔹 New: Refresh the section like resetSearch / Kamrul flow
          this.buildAndSearchQuery(); //  This will reload the product grid
        });
      }












      // === Vendor checkboxes ===
      this.tagsLinks = Array.from(document.querySelectorAll('#collections_all_filter_tag .facets__link'));
      this.tagsLinks.forEach(link => {
        const tagsinput = link.querySelector('input[type="checkbox"]');
        const tagsName = link.getAttribute('data-tag');

            if (tagsinput.checked) this.createTagMiniBox(tagsName, tagsinput);
          link.addEventListener('click', (e) => {
            e.preventDefault();
            tagsinput.checked = !tagsinput.checked;

            if (tagsinput.checked) {
              this.createTagMiniBox(tagsName, tagsinput);
            } else {
              this.removeTagMiniBox(tagsName);
            }

            this.buildAndSearchQuery();
          });

      });






      // === Vendor checkboxes ===
      this.vendorLinks = Array.from(document.querySelectorAll('#filter_vendor .facets__link'));
      this.vendorLinks.forEach(link => {
        const input = link.querySelector('input[type="checkbox"]');
        const vendorName = link.getAttribute('data-vendor');

        if (input.checked) this.createVendorMiniBox(vendorName, input);

        link.addEventListener('click', (e) => {
          e.preventDefault();
          input.checked = !input.checked;

          if (input.checked) {
            this.createVendorMiniBox(vendorName, input);
          } else {
            this.removeVendorMiniBox(vendorName);
          }

          this.buildAndSearchQuery();
        });
      });



    }

// Constructor Ending *************************************************************************************************************************************************






//Tag Part 22222222222222222222222222222222222222222222
sanitizeTagName(name) {
  return name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
}

createTagMiniBox(tagName, input) {
  const safeName = this.sanitizeTagName(tagName);
  if (document.querySelector(`#tag_mini_box_${safeName}`)) return;

  const miniBox = document.createElement('div');
  miniBox.className = 'active_search';
  miniBox.id = `tag_mini_box_${safeName}`;
  miniBox.innerHTML = `
    <span>${tagName}</span>
    <span class="remove_icon tag_rev_icon" id="remove_tag_${safeName}">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
           xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
           viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" 
           xml:space="preserve">
        <style type="text/css">.st0 { fill: #010101; }</style>
        <path class="st0" d="M59.5,140L59.5,140c-2.4-2.4-2.4-6.3,0-8.7l71.8-71.8c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7L68.2,140C65.8,142.5,61.9,142.5,59.5,140z"/>
        <path class="st0" d="M59.5,59.5L59.5,59.5c2.4-2.4,6.3-2.4,8.7,0l71.8,71.8c2.4,2.4,2.4,6.3,0,8.7l0,0c-2.4,2.4-6.3,2.4-8.7,0L59.5,68.3C57,65.8,57,61.9,59.5,59.5z"/>
      </svg>
    </span>
  `;

  this.vendorWrapper.appendChild(miniBox);

  miniBox.querySelector('.remove_icon').addEventListener('click', () => {
    input.checked = false;
    this.removeTagMiniBox(tagName);
    this.buildAndSearchQuery();
  });
}

removeTagMiniBox(tagName) {
  const safeName = this.sanitizeTagName(tagName);
  const miniBox = document.querySelector(`#tag_mini_box_${safeName}`);
  if (miniBox) miniBox.remove();
}

clearTags() {
  this.tagsLinks.forEach(link => {
    const input = link.querySelector('input[type="checkbox"]');
    input.checked = false;
  });

  const miniBoxes = this.vendorWrapper.querySelectorAll('.active_search');
  miniBoxes.forEach(box => box.remove());
}

//Tag Part End 22222222222222222222222222222222222222222222





// Vendor Part 222222222222222222222222222222222222222222

    sanitizeVendorName(name) {
      return name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    }

    createVendorMiniBox(vendorName, input) {
      const safeName = this.sanitizeVendorName(vendorName);
      if (document.querySelector(`#vendor_mini_box_${safeName}`)) return;

      const miniBox = document.createElement('div');
      miniBox.className = 'active_search';
      miniBox.id = `vendor_mini_box_${safeName}`;
      miniBox.innerHTML = `
        <span>${vendorName}</span>
        <span class="remove_icon vendor_rev_icon" id="remove_vendor_${safeName}">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
            <style type="text/css">.st0 { fill: #010101; }</style>
            <path class="st0" d="M59.5,140L59.5,140c-2.4-2.4-2.4-6.3,0-8.7l71.8-71.8c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7L68.2,140C65.8,142.5,61.9,142.5,59.5,140z"/>
            <path class="st0" d="M59.5,59.5L59.5,59.5c2.4-2.4,6.3-2.4,8.7,0l71.8,71.8c2.4,2.4,2.4,6.3,0,8.7l0,0c-2.4,2.4-6.3,2.4-8.7,0L59.5,68.3C57,65.8,57,61.9,59.5,59.5z"/>
          </svg>
        </span>
      `;

      this.vendorWrapper.appendChild(miniBox);

      miniBox.querySelector('.remove_icon').addEventListener('click', () => {
        input.checked = false;
        this.removeVendorMiniBox(vendorName);
        this.buildAndSearchQuery();
      });
    }


    removeVendorMiniBox(vendorName) {
      const safeName = this.sanitizeVendorName(vendorName);
      const miniBox = document.querySelector(`#vendor_mini_box_${safeName}`);
      if (miniBox) miniBox.remove();
    }

    clearVendors() {
      this.vendorLinks.forEach(link => {
        const input = link.querySelector('input[type="checkbox"]');
        input.checked = false;
      });

      const miniBoxes = this.vendorWrapper.querySelectorAll('.active_search');
      miniBoxes.forEach(box => box.remove());
    }
// Vendor Part End 222222222222222222222222222222222222222222222222222222222222









// === Real-time active item display ===
onInputChange() {
  const val = this.searchInput.value.trim();
  if (this.activeItem) this.activeItem.innerHTML = val;
  if (this.searchMiniBox) this.searchMiniBox.style.display = val ? 'flex' : 'none';
  this.debouncedSearch();
}




    debouncedSearch() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => this.buildAndSearchQuery(), 200);
    }



    
// buildAndSearchQuery() {
//   // ===  Vendors ===
//   const selectedVendors = this.vendorLinks
//     .filter(link => link.querySelector('input[type="checkbox"]').checked)
//     .map(link => link.getAttribute('data-vendor').trim().replace(/\s+/g, '+'));

//   // ===  Tags ===
//   const selectedTags = this.tagsLinks
//     .filter(link => link.querySelector('input[type="checkbox"]').checked)
//     .map(link => link.getAttribute('data-tag').trim().replace(/\s+/g, '+'));

//   // ===  Search Input ===
//   const searchQuery = this.searchInput.value.trim().replace(/\s+/g, '+');

//   // ===  Combine All Filters (Vendor + Tag) ===
//   const allFilters = [...selectedVendors, ...selectedTags];
//   let combinedQuery = '';

//   if (searchQuery && allFilters.length > 0) {
//     combinedQuery = `${searchQuery}+${allFilters.join('+')}`;
//   } else if (searchQuery) {
//     combinedQuery = searchQuery;
//   } else if (allFilters.length > 0) {
//     combinedQuery = allFilters.join('+');
//   }

//   const fullUrl = `${window.location.origin}/search?q=${combinedQuery}`;
//   console.log('%c[PredictiveSearch] Request URL:', 'color: green; font-weight: bold;', fullUrl);

  
//   const fullparams = `${combinedQuery}`;
//   this.search(fullUrl, fullparams);
  
// }
buildAndSearchQuery() {
  // === Vendors ===
  const selectedVendors = this.vendorLinks
    .filter(link => link.querySelector('input[type="checkbox"]').checked)
    .map(link => encodeURIComponent(link.getAttribute('data-vendor').trim()));

  // === Tags ===
  const selectedTags = this.tagsLinks
    .filter(link => link.querySelector('input[type="checkbox"]').checked)
    .map(link => encodeURIComponent(link.getAttribute('data-tag').trim()));

  // === Search Input ===
  const searchQuery = encodeURIComponent(this.searchInput.value.trim());

  // === Combine All Filters (Vendor + Tag) ===
  const allFilters = [...selectedVendors, ...selectedTags];
  let combinedQuery = '';

  if (searchQuery && allFilters.length > 0) {
    combinedQuery = `${searchQuery}+${allFilters.join('+')}`;
  } else if (searchQuery) {
    combinedQuery = searchQuery;
  } else if (allFilters.length > 0) {
    combinedQuery = allFilters.join('+');
  }

  // === Full Search URL with default type=product ===
  const fullUrl = `${window.location.origin}/search?type=product&q=${combinedQuery}`;
  console.log('%c[PredictiveSearch] Request URL:', 'color: green; font-weight: bold;', fullUrl);

  // Call search function
  this.search(fullUrl, combinedQuery);
}







async search(fullUrl, fullparams) {
  if (!fullUrl && !fullparams) return;

  const res = await fetch(fullUrl);
  const html = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // === Kamrul style update ===
  const newGrid = doc.querySelector('.product-grid')?.innerHTML || this.defaultResultsHTML;
  const newSortBy = doc.querySelector('#Top_bar_sorting')?.innerHTML || this.defaultSortByHTML;

  // Product grid update
  if (this.resultsContainer && this.sortByContainer) {
    this.resultsContainer.innerHTML = newGrid;
    this.sortByContainer.innerHTML = newSortBy;

    if (fullparams) {
      this.resultsContainer.setAttribute('ref', 'kamrul'); // Kamrul style ref
      this.sortByContainer.setAttribute('ref', 'kamrul');
    } else {
      this.resultsContainer.setAttribute('ref', 'grid');
      this.sortByContainer.setAttribute('ref', 'TopBarSortBy');
    }
  }

  // Reset button visibility
  this.resetButton.hidden =
    !this.searchInput.value &&
    !this.vendorLinks.some(l => l.querySelector('input').checked) &&
    !this.tagsLinks.some(l => l.querySelector('input').checked); //  include tags
}




resetSearch() {
  this.searchInput.value = '';

  // Default grid
  if (this.resultsContainer) {
    this.resultsContainer.innerHTML = this.defaultResultsHTML;
    this.resultsContainer.setAttribute('ref', 'grid'); // Default ref
  }

  // Default sort by
  if (this.sortByContainer) {
    this.sortByContainer.innerHTML = this.defaultSortByHTML;
    this.sortByContainer.setAttribute('ref', 'grid'); // Default ref
  }

  this.resetButton.hidden = true;
  this.clearVendors();
  this.clearTags(); //  Added tag clearing

  if (this.activeItem) this.activeItem.innerHTML = '';
  if (this.searchMiniBox) this.searchMiniBox.style.display = 'none';

  // Remove `q` from URL
  const url = new URL(location);
  url.searchParams.delete('q');
  history.replaceState(null, '', url.toString());
}



    onKeyDown(e) {
  const items = Array.from(this.resultsContainer.querySelectorAll('a, button'));
  if (!items.length) return;

  let index = items.findIndex(el => el.classList.contains('selected'));

  if (e.key === 'ArrowDown') {
    e.preventDefault();
    index = index < items.length - 1 ? index + 1 : 0;
    this.selectItem(items, index);
  }

  if (e.key === 'ArrowUp') {
    e.preventDefault();
    index = index > 0 ? index - 1 : items.length - 1;
    this.selectItem(items, index);
  }

  if (e.key === 'Enter' && index >= 0) {
    e.preventDefault();
    items[index].click();
  }
}




      selectItem(items, index) {
      items.forEach(el => el.classList.remove('selected'));
      items[index].classList.add('selected');
      items[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  customElements.define('predictive-search-component', PredictiveSearchComponent);
}
